import type { AudioFilePort } from '@Domain/Ports/AudioFile/AudioFilePort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useAudioFilePort(): AudioFilePort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useAudioFilePort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.audioFile;
}

export default useAudioFilePort;
